// removed by extract-text-webpack-plugin
module.exports = {"fieldset":"_24YVaHLziLQJ5vHPRgUtad","smallFieldSet":"_2nBSaQuaupH13lHimgjgJB","form":"_3gMPxNu_W5SUi2hu3B6rjn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/FieldTemplates/ObjectFieldTemplate/style.css
// module id = 1256
// module chunks = 0